<mat-toolbar class="topbar horizontal-topbar">
  <div class="container">
    <div class="d-none d-sm-flex">
      <!--<app-branding></app-branding>-->
    </div>

    <!-- Mobile Menu -->
    <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-block d-lg-none">
      <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
    </button>
    <!-- --------------------------------------------------------------- -->


    <div class="d-none d-lg-flex">
      <!-- --------------------------------------------------------------- -->
      <!--  Links -->
      <!-- --------------------------------------------------------------- -->
      <button mat-button [matMenuTriggerFor]="appsmenu" aria-label="Notifications">
        <div class="d-flex align-items-center">
          {{ currentModule }} <i-tabler name="chevron-down" class="icon-16 m-l-4"></i-tabler>
        </div>
      </button>
      <mat-menu #appsmenu="matMenu" class="apps-dd cardWithShadow">
        <div class="row">
          <div class="col-sm-12 b-r-1 p-r-0">
            <div class="p-32 p-b-0">
              <div class="row">
                <ng-container *ngFor="let app of apps">
                  <div class="col-sm-6 text-hover-primary" [cluPermission]="!!authSessionDto && !!app.PERMISSIONS ? app.PERMISSIONS : []">
                    <a [routerLink]="[app.link]" class="d-flex align-items-center text-decoration-none m-b-24">
                      <span class="text-primary bg-light-primary rounded icon-40 d-flex align-items-center justify-content-center">
                        <img [src]="app.img" width="20" />
                      </span>

                      <div class="m-l-16">
                        <h5 class="f-s-14 f-w-600 m-0 textprimary mat-body-1 hover-text"> {{ app.title }} </h5>
                        <span class="mat-body-1 f-s-12">{{ app.subtitle }}</span>
                      </div>
                    </a>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="b-t-1 p-24 d-none d-lg-flex align-items-center justify-content-between">
              <span class="d-flex align-items-center mat-subtitle-1 f-s-16 f-w-500">
                <i-tabler name="lock" class="icon-20 m-r-8"></i-tabler >{{ "Interface d'administration" | translate }}
              </span>
              <a [routerLink]="['/cluadmin/login']" mat-flat-button color="primary">Allons-y</a>
            </div>
          </div>
        <!--
          <div class="col-sm-4">
            <div class="p-x-16 p-y-32">
              <h4 class="f-s-18 f-w-600 mat-subtitle-1 m-b-16">Quick Links</h4>
              <div class="text-hover-primary" *ngFor="let quicklink of quicklinks">
                <a [routerLink]="[quicklink.link]" class="hover-text text-decoration-none mat-body-1 f-w-600 d-block p-y-8">{{ quicklink.title }}</a>
              </div>
            </div>
          </div>
        -->
        </div>
      </mat-menu>
    </div>

    <span class="flex-1-auto"></span>

    <!-- Mobile Menu -->
    <button mat-icon-button (click)="toggleMobileFilterNav.emit()" class="d-flex d-lg-none justify-content-center">
      <i-tabler name="grid-dots" class="icon-20 d-flex"></i-tabler>
    </button>

  <button mat-button class="d-flex m-r-5 justify-content-center" [matTooltip]="'Synchronisation de la caisse en cours (' + progressPercent + '%)...'" *ngIf="isSyncInProgress">
     <mat-progress-spinner
        color="primary"
        mode="indeterminate"
        diameter="20"
        [value]="progressPercent">
    </mat-progress-spinner>
  </button>
  <button mat-icon-button class="d-flex m-r-5 justify-content-center" (click)="toggleGhostMode()">
    <i-tabler *ngIf="!ghostMode" name="wifi" class="icon-20 d-flex"></i-tabler>
    <i-tabler *ngIf="ghostMode" name="ghost" class="icon-20 d-flex"></i-tabler>
  </button>
  <button mat-button [matMenuTriggerFor]="siteMenu">
    <div class="d-flex align-items-center">
      {{ authSessionDto.SITE_ITEM?.S_DENOMINATION }} <i-tabler name="chevron-down" class="icon-16 m-l-4"></i-tabler>
    </div>
  </button>
  <mat-menu #siteMenu="matMenu" class="cardWithShadow">
    <!-- CAISSE -->
    <ng-container *ngIf="!!authSessionDto.FO_PARAMS && authSessionDto.FO_PARAMS.M_CAISSE == true && !!authSessionDto.FO_PARAMS.M_CAISSE_PERM && !!authSessionDto.FO_PARAMS.M_CAISSE_PERM.CASHIER_ITEM && !!authSessionDto.FO_PARAMS.M_CAISSE_PERM.CASHIER_ITEM.DEVICES_CASHIERS">
      <button mat-menu-item *ngFor="let deviceItem of authSessionDto.FO_PARAMS.M_CAISSE_PERM.CASHIER_ITEM.DEVICES_CASHIERS;" (click)="onCashdeskPickedEvent(deviceItem.CAISSE)">
        <div class="d-flex align-items-center" style="padding: 8px; border-radius: 5px;" [style.background]="currentCashdeskGID == deviceItem.CAISSE.CAISSEGID ? '#5d87ff' : 'transparent'">
          <span class="mat-subtitle-1 f-s-12 f-w-600"><span style="color: #bec3cd; margin-right: 10px; font-size: 10px;">[{{ deviceItem.CAISSE.C_NO  }}]</span>{{ deviceItem.CAISSE.C_DENOMINATION  }}</span>
        </div>
      </button>
    </ng-container>
  </mat-menu>

    <!-- --------------------------------------------------------------- -->
    <!-- profile Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <button mat-icon-button [matMenuTriggerFor]="profilemenu" aria-label="Notifications" (click)="checkForMessages()">
      <img src="assets/images/profile/ninja-fo.png" class="rounded-circle object-cover" width="35" />
    </button>
    <mat-menu #profilemenu="matMenu" xPosition="before" class="topbar-dd cardWithShadow" >
      <div class="p-x-32 p-y-16">
        <h6 class="f-s-16 f-w-600 m-0">{{ "Front-Office - Utilisateur" | translate }}</h6>

        <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16">
          <img
            src="assets/images/profile/ninja-fo.png"
            class="rounded-circle"
            width="95"
          />
          <div class="m-l-16">
            <h6 class="f-s-14 f-w-600 m-0">{{ authSessionDto.USERNAME }}</h6>
            <span class="f-s-14 d-block m-b-4">{{ authSessionDto.PRENOM }} {{ authSessionDto.NOM }}</span>
            <span class="f-s-12 d-block m-b-4">{{ authSessionDto.EMAIL }}</span>
          </div>
        </div>
      </div>
      <div class="p-x-32">
        <a routerLink="/apps/profile" class="p-y-16 text-decoration-none d-block text-hover-primary">
          <div class="d-flex align-items-center">
            <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
              <img src="assets/images/svgs/icon-account.svg" width="20" />
            </button>
            <div class="m-l-16">
              <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                {{ "Mon compte" | translate }}
              </h5>
              <span class="mat-body-1">{{ "Modifier les infos du compte" | translate }}</span>
            </div>
          </div>
        </a>
      </div>
      <div class="p-x-32">
        <a (click)="doLockAccount()" class="p-y-16 text-decoration-none d-block text-hover-primary">
          <div class="d-flex align-items-center">
            <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
              <i-tabler name="lock-square-rounded" style="font-size: 30px"></i-tabler>
            </button>
            <div class="m-l-16">
              <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                {{ "Verrouiller la session" | translate }}
              </h5>
              <span class="mat-body-1">{{ "Verrouiller la session" | translate }}</span>
            </div>
          </div>
        </a>
      </div>
      <div class="p-y-0 p-x-32 d-flex" (click)="$event.stopPropagation()">
        <!-- --------------------------------------------------------------- -->
        <!-- langugage Dropdown -->
        <!-- --------------------------------------------------------------- -->
        <button [matMenuTriggerFor]="flags" mat-icon-button class="m-r-5">
          <img [src]="selectedLanguage.icon" class="rounded-circle object-cover icon-20" />
        </button>
        <span style="font-weight: 700;margin: auto; margin-left: 0;">{{selectedLanguage.language}}</span>
        <mat-menu #flags="matMenu" class="cardWithShadow">
          <button mat-menu-item *ngFor="let lang of languages" (click)="changeLanguage(lang)" >
            <div class="d-flex align-items-center">
              <img [src]="lang.icon" class="rounded-circle object-cover m-r-8 icon-20" />
              <span class="mat-subtitle-1 f-s-14">{{ lang.language }}</span>
            </div>
          </button>
        </mat-menu>
      </div>
      <div class="p-x-32">
        <div class="p-y-16 text-decoration-none d-block text-hover-primary">
          <div class="d-flex align-items-center">
            <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
              <i-tabler name="license" style="font-size: 30px"></i-tabler>
            </button>
            <div class="m-l-16">
              <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                {{ "Licence" | translate }}
              </h5>
              <div *ngIf="appVersion?.NF525 === true" style="background: #4575c8;color: white;font-size: 12px;display: flex;justify-content: center;position: absolute;top: 1px;left: 60px;padding: 2px;border-radius: 10px;">
                NF525
              </div>
              <span class="mat-body-1">{{ "Date Expiration" | translate }}: {{ authSessionDto.LICENCE_DATE_EXPIRATION | date:'dd/MM/yyyy' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="p-x-32">
        <a routerLink="/apps/release-notes" class="p-y-16 text-decoration-none d-block text-hover-primary">
          <div class="d-flex align-items-center">
            <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
              <i-tabler name="clipboard-text" style="font-size: 30px"></i-tabler>
            </button>
            <div class="m-l-16">
              <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                {{ "Release Notes" | translate }}
              </h5>
              <span class="mat-body-1">{{ "Notes de version" | translate }}</span>
            </div>
          </div>
        </a>
      </div>
      <div class="p-x-32">
        <a (click)="openAboutDialog()" class="p-y-16 text-decoration-none d-block text-hover-primary">
          <div class="d-flex align-items-center">
            <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
              <i-tabler name="clipboard-text" style="font-size: 30px"></i-tabler>
            </button>
            <div class="m-l-16">
              <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                {{ "A propos" | translate }}
              </h5>
              <span class="mat-body-1">Cauris Link Up</span>
            </div>
          </div>
        </a>
      </div>
      <div class="p-y-12 p-x-32">
        <a (click)="doLogout()" mat-stroked-button color="primary" class="w-100">{{ "Se deconnecter" | translate }}</a>
      </div>
    </mat-menu>

    <ng-container *ngIf="isTauri">
      <button mat-icon-button aria-label="Réduire" matTooltip="Réduire l'application" class="d-flex justify-content-center" (click)="doMinimizeApp()">
        <i-tabler name="window-minimize" style="color: #073869;" class="icon-24 d-flex"></i-tabler>
      </button>

      <button mat-icon-button aria-label="Quitter" matTooltip="Quitter l'application" class="d-flex justify-content-center" (click)="doQuitApp()">
        <i-tabler name="square-rounded-x-filled"  style="color: #073869;" class="icon-24 d-flex"></i-tabler>
      </button>
    </ng-container>
  </div>
</mat-toolbar>
